import {SET_LOADING_GET_ROLES, GET_ROLES, GET_ROLES_SUCCESS, GET_ROLES_ERROR, 
    SET_LOADING_DELETE_ROLE, DELETE_ROLE, DELETE_ROLE_SUCCESS, DELETE_ROLE_ERROR,
    SET_LOADING_POST_ROLE, POST_ROLE, POST_ROLE_SUCCESS, POST_ROLE_ERROR,
    SET_LOADING_PATCH_ROLE, PATCH_ROLE, PATCH_ROLE_SUCCESS, PATCH_ROLE_ERROR,
    SET_LOADING_GET_ROLE, GET_ROLE, GET_ROLE_SUCCESS, GET_ROLE_ERROR} from '../actions/RoleActions';

const INITIAL_STATE = {
    loadingGetRoles: false, 
    loadingDeleteRole: false,
    loadingPostRole: false,
    loadingPatchRole: false,
    loadingGetRole: false
};

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case SET_LOADING_GET_ROLES:
            return {...state, loadingGetRoles: true}
        case GET_ROLES:
            return {...state}
        case GET_ROLES_SUCCESS:
            return {...state, loadingGetRoles: false}
        case GET_ROLES_ERROR:
            return {...state, loadingGetRoles: false}

        case SET_LOADING_DELETE_ROLE:
            return {...state, loadingDeleteRole: true}
        case DELETE_ROLE:
            return {...state}
        case DELETE_ROLE_SUCCESS:
            return {...state, loadingDeleteRole: false}
        case DELETE_ROLE_ERROR:
            return {...state, loadingDeleteRole: false}

        case SET_LOADING_POST_ROLE:
            return {...state, loadingPostRole: true}
        case POST_ROLE:
            return {...state}
        case POST_ROLE_SUCCESS:
            return {...state, loadingPostRole: false}
        case POST_ROLE_ERROR:
            return {...state, loadingPostRole: false}
    
        case SET_LOADING_PATCH_ROLE:
            return {...state, loadingPatchRole: true}
        case PATCH_ROLE:
            return {...state}
        case PATCH_ROLE_SUCCESS:
            return {...state, loadingPatchRole: false}
        case PATCH_ROLE_ERROR:
            return {...state, loadingPatchRole: false}

        case SET_LOADING_GET_ROLE:
            return {...state, loadingGetRole: true}
        case GET_ROLE:
            return {...state}
        case GET_ROLE_SUCCESS:
            return {...state, loadingGetRole: false}
        case GET_ROLE_ERROR:
            return {...state, loadingGetRole: false}
        default:
            return state;
    }
}
